import fetch from '@/config/fetch';
import fetchNew from '@/config/fetchNew';

export const updateSupplierByCarIdsShip = (data) => fetch('/platform/shipDeploy/updateSupplierByCarIds', data, 'POST');

export const updateSupplierByCarIds = (data) => fetch('/platform/deployFleet/updateSupplierByCarIds', data, 'POST');

export const updateSupplierHC = (data) => fetch(`/platform/sys/shipVoyageNumber/updateSupplier/${data.id}/${data.supplierId}`, data, 'POST');

// 提交修改供应商数据申请
export const updateSupplier = (data) => fetch(`/platform/deployFleet/updateSupplier/${data.id}/${data.supplierId}`, data, 'POST');

// 提交修改数据申请
export const commit = (data) => fetch('/platform/transportChild/update/commit', data, 'POST');

/**
 * 预报计划
 */
// 预报计划 —— 分页查询
export const pageList = (data) => fetch('/platform/predictionPlan/pageList', data, 'GET');
//下拉查询品牌
export const yearSelectBrandByAll = (data) => fetch('/platform/car/brand/selectBrandByAll', data, 'GET');
// 新增
export const predictionAdd = (data) => fetch('/platform/predictionPlan/add', data, 'POST');
// 获取船舶
export const selectAllShip = () => fetch('/platform/supplierShip/selectAllShip', {}, 'GET');
// 生成预配计划
export const predictionPlanAdd = (data) => fetch('/platform/predictionPlan/addTransportPredictionPlan', data, 'POST');
// 预配计划 —— 分页查询
export const provisionPageList = (data) => fetch('/platform/predictionPlan/selTransportPredictionPlan', data, 'GET');
// 预配计划 —— 详情
export const provisioningDetail = (id) => fetch('/platform/predictionPlan/transportPredictionPlanDetail', id, 'GET');
// 预配计划 —— 删除
export const provisionDelete = (id) => fetch('/platform/predictionPlan/delTransportPredictionPlan', id, 'POST');
// 预配计划 —— 打印第一步
export const provisioningPrint1 = (id) => fetch('/platform/predictionPlan/printTransportPredictionPlan', id, 'GET');

export const predictionDelete = (id) => fetch(`/platform/predictionPlan/delete/${id}`, {}, 'POST');

export const predictionUpdate = (data) => fetch('/platform/predictionPlan/update', data, 'POST');


/**
 * 预报计划
 */
export const planPageList = (data) => fetch('/platform/ym-plan-cv/pageList', data, 'GET');

export const planAdd = (data) => fetch('/platform/ym-plan-cv/add', data, 'POST');

export const planDelete = (id) => fetch(`/platform/ym-plan-cv/delete/${id}`, {}, 'POST');

export const planUpdate = (data) => fetch('/platform/ym-plan-cv/update', data, 'POST');

export const planDetail = (id) => fetch(`/platform/ym-plan-cv/detail/${id}`, {}, 'GET');
/**
 * 年月计划管理
 */
//查询
export const getPlanPageList = (data) => fetch('/platform//summarize/all/list', data, 'POST');
//详情
export const detailPlan = (id) => fetch(`/platform/summarize/all/detail/${id}`, {}, 'GET');
//新增
export const addPlan = (data) => fetch('/platform/summarize/all/add', data, 'POST');
//修改
export const updatePlan = (data) => fetch('/platform/summarize/all/update', data, 'POST');
//删除
export const deletePlan = (ids) => fetch(`/platform/summarize/all/deleteMore/${ids}`, {}, 'POST');
//撤回
export const withdraw = (data) => fetch('/platform/summarize/all/withdraw', data, 'POST');
//送审
export const resubmit = (data) => fetch('/platform/summarize/all/resubmit', data, 'POST');
//同意/拒绝
export const examinePassFail = (data) => fetch('/platform/summarize/all/examinePassFail', data, 'POST');
//解锁
export const lockUnlock = (data) => fetch('/platform/summarize/all/lockUnlock', data, 'POST');
//详情-新增多个
export const addColumnMore = (data) => fetch('/platform/summarize/all/addColumnMore', data, 'POST');
//详情-修改回显
export const getComment = (data) => fetch('/platform/summarize/all/getComment', data, 'GET');
//详情-修改
export const updateColumn = (data) => fetch('/platform/summarize/all/updateColumn', data, 'POST');
//详情-修改-新增一个
export const addColumn = (data) => fetch('/platform/summarize/all/addColumn', data, 'POST');
//详情-修改-删除
export const delColumn = (data) => fetch('/platform/summarize/all/delColumn', data, 'POST');
//详情-获取表格数据
export const getTableDatas = (data) => fetch('/platform/summarize/all/getData', data, 'GET');
//详情-删除
export const delData = (data) => fetch('/platform/summarize/all/delData', data, 'POST');
//详情-保存
export const saveData = (data) => fetch('/platform/summarize/all/saveData', data, 'POST');
//详情-修改
export const updateTableData = (data) => fetch('/platform/summarize/all/updateData', data, 'POST');


/**
 *运输计划
 */
// 运输计划 —— 分页查询
export const transportPlanCvPageList = (data) => fetch('/platform/transport-plan-cv/pageList', data, 'POST');
// 委托车 —— 分页查询
export const entrustedCarPageList = (data) => fetch('/platform/transportChild/pageList', data, 'POST');
// 运输计划 —— 删除
export const deleteTransportPlan = (data) => fetch(`/platform/transport-plan-cv/deletePlan?id=${data}`, {}, 'POST');
// 运输计划 —— 锁定
export const lockingTransportPlan = (data) => fetch(`/platform/transport-plan-cv/lockBatchPlan?id=${data}`, {}, 'POST');
// 运输计划 —— 取消锁定
export const unlockingTransportPlan = (data) => fetch(`/platform/transport-plan-cv/unlockBatchPlan?id=${data}`, {}, 'POST');
// 运输计划/委托车 —— 新增
export const getAddressAdd = (data) => fetch('/platform/transport-plan-cv/add', data, 'POST');
// 运输计划/委托车 —— 修改
export const transportPlanCvUpdate = (data) => fetch('/platform/transport-plan-cv/update', data, 'POST');

export const getPlanParam = (data) => fetch('/platform/predictionPlan/selectPredictionByAll', data, 'GET');

export const getPlanUpdateStatus = (data) => fetch(`/platform/transport-plan-cv/updateStatus/${data.id}?status=${data.data}`, {}, 'POST');
// 运输计划 —— 详情
export const transportPlanCvDetail = (id) => fetch(`/platform/transport-plan-cv/detail/${id}`, {}, 'GET');
// 运输计划 —— 委托车导出
export const entrustedExport = (data) => fetch('/platform/transportChild/childCvExport', data, 'POST');
// 运输计划 —— 修改详情
export const transportPlanChDetail = (id) => fetch(`/platform/transport-plan-cv/updateDetail/${id}`, {}, 'GET');
// 运输计划 —— 委托车列表
export const updateCarList = (id) => fetch(`/platform/transportChild/updateDetailList/${id}`, {}, 'GET');
// 运输计划 —— 委托车新增
export const entrustedAdd = (data) => fetch('/platform/transportChild/add', data, 'POST');
// 运输计划 —— 委托车删除
export const entrustedDel = (id) => fetch(`/platform/transportChild/delete/${id}`, {}, 'POST');
// 运输计划 —— 委托车修改
export const entrustedEdit = (data) => fetch('/platform/transportChild/update', data, 'POST');
// 运输计划 —— 目的地修改
export const batchUpdateDestination = (data) => fetch('/platform/transportChild/batchUpdateDestination', data, 'POST');
// 委托车 —— 详情
export const entrustedCvDetail = (id) => fetch(`/platform/transportChild/detail/${id}`, {}, 'GET');

export const transportPlanCvGetPlanDetail = (id) => fetch(`/platform/transport-child-cv/getPlanDetail/${id}`, {}, 'GET');

export const getBrandParam = (data) => fetch('/platform/transport-child-cv/getBrandParam', data, 'GET');

export const getModelParam = (data) => fetch('/platform/transport-child-cv/getModelParam', data, 'GET');

export const getConfigParam = (data) => fetch('/platform/transport-child-cv/getConfigParam', data, 'GET');

export const getCarSerieList = (data) => fetch('/platform/car/brand/getCarSerieList', data, 'GET');

export const selectOpt = (data) => fetch('/platform/sys/lineConfig/selectOpt', data, 'GET');

export const getAddress = (data) => fetch('/platform/transport-child-cv/getAddress', data, 'GET');

export const getAddressDetail = (id) => fetch(`/platform/transport-child-cv/getAddressDetail/${id}`, {}, 'GET');
//线路设置
export const publicSelectLine = (data) => fetch('/platform/sys/lineConfig/publicSelectLine', data, 'GET');
//批量删除批次号
export const transportPlanCvDeleteBatchNumber = (data) => fetch(`/platform/transport-plan-cv/deleteBatchNumber?batchNumber=${data}`, {}, 'POST');
//批量删除运单号
export const transportPlanCvDeleteBatchWaybillNumber = (data) => fetch(`/platform/transportChild/delWaybillNo?waybillNos=${data}`, {}, 'POST');
//批量删除车架号
export const transportPlanCvDeleteBatchFrameNumber = (data) => fetch(`/platform/transportChild/delFrameNumber?ids=${data}`, {}, 'POST');
//批量锁定计划
export const transportPlanCvLockBatchPlan = (data) => fetch(`/platform/transport-plan-cv/lockBatchPlan?planId=${data}`, {}, 'POST');
//批量解锁计划
export const transportPlanCvUnlockBatchPlan = (data) => fetch(`/platform/transport-plan-cv/unlockBatchPlan?planId=${data}`, {}, 'POST');
//批量锁定委托车
export const transportPlanCvLockBatchEntrustCar = (data) => fetch(`/platform/transportChild/lockChild?ids=${data}`, {}, 'POST');
//批量解锁委托车
export const transportPlanCvUnlockBatchEntrustCar = (data) => fetch(`/platform/transportChild/unlockChild?ids=${data}`, {}, 'POST');
//批量修改委托车
export const transportPlanCvModifyBatchEntrustCar = (data) => fetch('/platform/transport-plan-cv/modifyBatchEntrustCar', data, 'POST');
//批量修改线路选择
export const transportPlanCvModifyBatchLineInfo = (data) => fetch('/platform/transport-plan-cv/modifyBatchLineInfo', data, 'POST');


/**
 * 接口运输计划
 */
// 分页查询
export const importPlanCvPageList = (data) => fetch('/platform/inter/transportChild/pageList', data, 'GET');
// 新增
export const importPlanAdd = (data) => fetch('/platform/inter/transportChild/addTransportPlen', data, 'POST');
// 港口
export const getPortList = (data) => fetch('/platform/inter/transportChild/suppletList', data, 'POST');

/**
 * 完善运输计划
 */
// 分页查询
export const comportPlanPageList = (data) => fetch('/platform/transportChild/pageCarDataperfection', data, 'GET');
// 生成计划
export const comportPlanAdd = (data) => fetch('/platform/transportChild/generateTransportationPlan', data, 'POST');


/**
 *车辆调配管理
 */
// 新增
export const vehicleDeployInfoCvAdd = (data) => fetch('/platform/deployFleet/add', data, 'POST');
// 修改
export const vehicleDeployInfoUpdate = (data) => fetch('/platform/deployFleet/update', data, 'POST');
// 删除
export const vehicleDeployInfoDelete = (data) => fetch(`/platform/deployFleet/delete/${data}`, {}, 'GET');
// 完成
export const vehicleDeployInfoFinish = (data) => fetch('/platform/deployFleet/fulfilState', data, 'POST');
// 修改交车地
export const changeDelivery = (data) => fetch('/platform/deployFleet/updateDeployFleet', data, 'POST');

export const vehicleDeployInfoCvGetTypeInfo = (id) => fetch(`/platform/vehicle-deploy-car-cv/getTypeInfo/${id}`, {}, 'GET');

export const vehicleDeployInfoCvGetCarById = (id, data) => fetch(`/platform/vehicle-deploy-car-cv/getCarById/${id}`, data, 'GET');
//运输车管理 所属供应商下拉
export const getHighwayParam = () => fetch('/platform/highwaySupplier/selectList', {}, 'GET');

export const getCarByIdParam = (id) => fetch(`/platform/paramCategoryAttr/getCarByIdParam/${id}`, {}, 'GET');

export const vehicleDeployInfoCvPageList = (data) => fetch('/platform/vehicle-deploy-info-cv/pageList', data, 'GET');

export const vehicleDeployInfoCvDelete = (id) => fetch(`/platform/vehicle-deploy-info-cv/delete/${id}`, {}, 'POST');

export const vehicleDeployInfoCvDetail = (id, type) => fetch(`/platform/vehicle-deploy-info-cv/detail/${id}?type=${type}`, {}, 'GET');

export const vehicleDeployInfoCvUpdateByStatus = (data) => fetch('/platform/vehicle-deploy-info-cv/updateByStatus', data, 'POST');

export const vehicleDeployInfoCvAddTransportVehicle = (data) => fetch('/platform/deployDriver/addDeployDriver', data, 'POST');

export const vehicleDeployInfoCvUpdate = (data) => fetch('/platform/vehicle-deploy-info-cv/update', data, 'POST');
//委托商仓库选择
export const vehiclePublicSelectWarehouse = (data) => fetch('/platform/sys/customerWarehouseInfo/publicSelectWarehouse', data, 'GET');
//港口供应商下拉查询
export const supplierPublicSelectPort = (data) => fetch('/platform/sys/supplierPort/publicSelectPort', data, 'GET');
export const supplierPublicSelectDistributor = (data) => fetch('/platform/distributor/publicSelectDistributor', data, 'GET');
// 通过区域查询港口
export const getSelectPort = (data) => fetch(`/platform/sys/supplierPort/getPortByArea?areaId=${data}`, {}, 'POST');
//通过所在位置类型、所在位置id查询托运车(调配需要)
export const vehiclGetChildByPosition = (data) => fetch('/platform/transportChild/getChildByPosition', data, 'GET');
// 水路装卸管理  通过 装车港口，装车船舶，查询运拖车
export const vehicleDeployCarGetStayLoadingByShip = (data) => fetch('/platform/vehicleDeployCar/getStayLoadingByShip', data, 'GET');
//手动装车
export const vehiclAddScanOperation = (data) => fetch('/platform/transportScanOperation/addScanOperation', data, 'POST');
// 首端 -- 分页查询
export const startFringeList = (data) => fetch('/platform/transportChild/pageHeadEndList', data, 'GET');
// 末端 -- 分页查询
export const endFringeList = (data) => fetch('/platform/transportChild/pageBackEndList', data, 'GET');


/**
 *船舶调配管理
 */
export const shipDeployPageList = (data) => fetch('/platform/shipDeploy/pageList', data, 'GET');

export const shipDeployGetShips = (data) => fetch('/platform/vehicle-deploy-car-cv/getShips', data, 'GET');

export const shipDeployGetPorts = (data) => fetch('/platform/vehicle-deploy-car-cv/getPorts', data, 'GET');
//下拉查询可调配的船舶
export const shipDeploySelectShipAvailable = (data) => fetch('/platform/supplierShip/selectShipAvailable', data, 'GET');

// 一键装车
export const oneLoading = (data) => fetch('/platform/transportChild/onekeyDeployment', data, 'GET');
//港口供应商下拉查询
export const shipDeployPublicSelectPort = (data) => fetch('/platform/sys/supplierPort/publicSelectPort', data, 'GET');
// 港口及其他
export const supplierListSelectPort = (data) => fetch('/platform/sys/supplierPortOther/sleectSupplierList', data, 'GET');
// 查询装车港口
export const getLoadingPort = (data) => fetch('/platform/sys/supplierPort/getPortAndLoadNum', data, 'GET');
// 新增
export const shipDeployAdd = (data) => fetch('/platform/shipDeploy/add', data, 'POST');
// 删除
export const shipDeployDelete = (id) => fetch(`/platform/shipDeploy/delete/${id}`, {}, 'POST');

export const shipDeployDetail = (id) => fetch(`/platform/shipDeploy/detail/${id}`, {}, 'GET');

export const shipDeployUpdateDetail = (id) => fetch(`/platform/shipDeploy/updateDetail/${id}`, {}, 'GET');
// 修改
export const shipDeployUpdate = (data) => fetch('/platform/shipDeploy/update', data, 'POST');
// 完成调配
export const shipDeployFinish = (id) => fetch(`/platform/shipDeploy/fulfilDeploy/${id}`, {}, 'POST');
// 添加装船港口
export const loadPortAdd = (data) => fetch('/platform/shipDeployPort/addShipPort', data, 'POST');

/**
 * 水路在途委托车统计
 */
export const waterStatList = (data) => fetch('/platform/transportChild/waterWayModelStatisticsList', data, 'POST');

// 详情-委托车
export const vehicleDetailPageList = (data) => fetch('/platform/vehicleDeployCar/pageList', data, 'GET');

/**
 *任务管理(公路)
 */
export const vehicleDeployFleetCvPageList = (data) => fetch('/platform/deployFleet/pageList', data, 'GET');
export const endListDetails = (data) => fetch('/platform/transportChild/endListDetails', data, 'GET');
// 详情
export const vehicleDeployFleetCvDetail = (id) => fetch(`/platform/deployFleet/detail/${id}`, {}, 'GET');
//分配运输车
export const vehicleDeploygetDistributionByCar = (data) => fetch('/platform/deployFleet/getDistributionByCar', data, 'GET');

// 品牌
export const getModelList = (data) => fetch('/platform/car/brand/selectBrandByAll', data, 'GET');
// 获取计量单位
export const getUnitOfMeasurement = (data) => fetch('/platform/portWarehouseCost/getUnit', data, 'GET');

/**
 * 司机装车管理
 */
// 分页查询
export const driverLoadingPageList = (data) => fetch('/platform/deployDriver/pageList', data, 'GET');
// 完成装车
export const driverLoadingFinish = (data) => fetch('/platform/deployDriver/fulfilLoading', data, 'POST');
// 完成运输
export const driverTransportFinish = (data) => fetch('/platform/deployDriver/fulfilTransport', data, 'POST');
// 详情
export const driverLoadingDetail = (id) => fetch(`/platform/deployDriver/detail/${id}`, {}, 'GET');
// 分段装车
export const driverLoadingTask = (data) => fetch('/platform/deployDriver/driverLoadingTask', data, 'POST');
// 分段交车
export const addUnloadPrice = (data) => fetch('/platform/deployFleet/addUnloadPrice', data, 'POST');
// 分段交车查询
export const addUnloadPriceList = (data) => fetch('/platform/vehicleDeployCar/segmentedEntrustedVehicleQuery', data, 'GET');

/**
 * 公路在途委托车统计
 */
export const highwayStatList = (data) => fetch('/platform/transportChild/highWayModelStatistics', data, 'POST');


/**
 *扫码装车
 */
export const vehicleGetSupplierByAppointPosition = (data) => fetch('/platform/deployFleet/getSupplierByAppointPosition', data, 'GET');

export const getCarByFleetId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getCarByFleetId/${id}`, {}, 'GET');

export const getTruckCarBySupplier = (data) => fetch('/platform/deployFleet/getTruckCarBySupplier', data, 'GET');

export const getInfoByDriverId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getInfoByDriverId/${id}`, {}, 'GET');

export const enTrucking = (data) => fetch('/platform/entruck-info-cv/enTrucking', data, 'POST');

export const entruckInfoCvPageList = (data) => fetch('/platform/transportScanOperation/pageLoadingList', data, 'GET');

export const entruckInfoCvSelectSupplierByDeployId = (id) => fetch('/platform/deployFleet/selectSupplierByDeployId', { 'deployId': id }, 'GET');

export const cancel = (id) => fetch(`/platform/entruck-info-cv/cancel/${id}`, {}, 'POST');
//查询委托车
export const selectCarByPosition = (data) => fetch('/platform/vehicleDeployCar/selectCarByPosition', data, 'GET');

/**
 *换版管理
 */
export const changeInfoCvPageList = (data) => fetch('/platform/vehicleChange/pageList', data, 'GET');

// export const changeInfoCvGetInfoByBill = ( id ) => fetch( `/platform/vehicle-deploy-car-cv/getInfoByBill/${id}`, {}, 'GET')
export const changeInfoCvGetInfoByBill = (id) => fetch(`/platform/vehicleChange/getVehicleByDriverTaskNumber?driverTaskNumber=${id}`, {}, 'GET');

export const changeInfoCvGetCarByFleetId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getCarByFleetId/${id}`, {}, 'GET');

export const changeInfoCvGetInfoByDriverId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getInfoByDriverId/${id}`, {}, 'GET');

// export const changeInfoCvAdd = ( data ) => fetch( `/platform/change-info-cv/add`, data, 'POST')
export const changeInfoCvAdd = (data) => fetch('/platform/vehicleChange/add', data, 'POST');

// export const changeInfoCvDelete = ( id ) => fetch( `/platform/change-info-cv/delete/${id}`, {}, 'POST')
export const changeInfoCvDelete = (id) => fetch(`/platform/vehicleChange/delete?id=${id}`, {}, 'GET');

// export const changeInfoCvDetail = ( id ) => fetch( `/platform/change-info-cv/detail/${id}`, {}, 'GET')
export const changeInfoCvDetail = (id) => fetch(`/platform/vehicleChange/detail?id=${id}`, {}, 'GET');


/**
 *线路设置
 */
export const lineConfigurePageList = (data) => fetch('/platform/sys/lineConfig/pageList', data, 'POST');

export const lineConfigureAdd = (data) => fetch('/platform/sys/lineConfig/add', data, 'POST');

export const lineConfigureUpdate = (data) => fetch('/platform/sys/lineConfig/update', data, 'POST');

export const lineConfigureIsEnable = (id) => fetch(`/platform/sys/lineConfig/isEnable?id=${id}`, {}, 'POST');
// 删除
export const lineConfigureDelete = (id) => fetch(`/platform/sys/lineConfig/deleteLine/${id}`, {}, 'POST');

export const lineConfigDetail = (id) => fetch('/platform/sys/lineConfig/detail', id, 'GET');
export const lineConfigListByAddr = (data) => fetch('/platform/sys/lineConfig/lineListByAddr', data, 'GET');

// 获取港口
export const lineConfigurePort = (id) => fetch(`/platform/sys/supplierPort/selectPortList/${id}`, {}, 'GET');


/**
 *交车管理
 */
export const deliveryInfoCvPageList = (data) => fetch('/platform/transportScanOperation/pageDeliverList', data, 'GET');

export const deliveryInfoCvFail = (id) => fetch(`/platform/delivery-info-cv/fail/${id}`, {}, 'POST');

export const deliveryInfoCvDetail = (id) => fetch(`/platform/delivery-info-cv/detail/${id}`, {}, 'GET');

export const getFleet = (data) => fetch('/platform/vehicle-deploy-car-cv/getFleet', data, 'GET');

export const deliveryInfoCvGetCarByFleetId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getCarByFleetId/${id}`, {}, 'GET');

export const deliveryInfoCvGetTransportVehicle = (id) => fetch('/platform/deployFleet/getTransportVehicle', { 'id': id }, 'GET');

export const deliveryInfoCvGetWaitingDeliverySupplier = (id) => fetch('/platform/deployFleet/getWaitingDeliverySupplier', {'id': id}, 'GET');

export const deliveryInfoCvGetEntrustCar = (data) => fetch('/platform/deployFleet/getEntrustCar', data, 'GET');

export const deliveryInfoCvGetAddressByCarId = (id) => fetch(`/platform/vehicle-deploy-car-cv/getAddressByCarId/${id}`, {}, 'GET');

export const deliveryInfoCvAdd = (data) => fetch('/platform/transportScanOperation/addDriverScanDelivery', data, 'POST');

/**
 *航次管理
 */
export const shipVoyageNumberAdd = (data) => fetch('/platform/sys/shipVoyageNumber/add', data, 'POST');

export const shipVoyageNumberPageList = (data) => fetch('/platform/sys/shipVoyageNumber/pageList', data, 'POST');

export const shipVoyageNumberDelete = (id) => fetch(`/platform/sys/shipVoyageNumber/delete/${id}`, {}, 'POST');

export const shipVoyageNumberDetail = (id) => fetch(`/platform/sys/shipVoyageNumber/detail/${id}`, {}, 'GET');
export const voyageDataQuer = (id) => fetch(`/platform/sys/shipVoyageNumber/voyageDataQuery/${id}`, {}, 'GET');
export const dateCalculatio = (data) => fetch('/platform/sys/lineConfig/portLineQuery', data, 'GET');
// 查询未有航次的船舶
export const shipDocSelectShipByNotVoyage = (data) => fetch('/platform/supplierShip/selectShipByNotVoyage', data, 'GET');

export const voyageNumberGenerate = (data) => fetch('/platform/sys/shipVoyageNumber/voyageNumberGenerate', data, 'POST');

export const shipVoyageNumberUpdate = (data) => fetch('/platform/sys/shipVoyageNumber/update', data, 'POST');
// 航次完成
export const voyageFinish = (data) => fetch('/platform/sys/shipVoyageNumber/fulfilDeploy', data, 'POST');

/**
 *任务管理(水路)
 */
export const dockInfoCvWaterPageList = (data) => fetch('/platform/shipDeployPort/pageList', data, 'GET');
//详情
export const dockInfoCvWaterDetail = (id) => fetch(`/platform/shipDeployPort/detail/${id}`, {}, 'GET');
//详情 —— 分页查询
export const dockInfoDetailPageList = (data) => fetch('/platform/vehicleDeployCar/pageList', data, 'GET');
// 装车完成
export const loadingFinish = (id) => fetch(`/platform/shipDeployPort/loadFulfil/${id}`, {}, 'POST');
// 正常作业 装车
export const batchLoading = (data) => fetch('/platform/shipDeployPort/batchLoading', data, 'POST');
// 转船 装车
export const batchTurnLoading = (data) => fetch('/platform/shipDeployPort/batchTurnLoading', data, 'POST');
// 过驳/卸车(转船) 分页查询
export const refutePageList = (data) => fetch('/platform/vehicleDeployCar/pageTransferList', data, 'GET');
// 装车(转船) 分页查询
export const appointTurnLoading = (data) => fetch('/platform/vehicleDeployCar/appointTurnLoading', data, 'GET');
// 手动卸车 分页查询
export const pagePortTaskList = (data) => fetch('/platform/vehicleDeployCar/pagePortTaskList', data, 'GET');
// 手动卸车 卸车船舶
export const selectUnloadShip = (data) => fetch('/platform/supplierShip/selectUnloadShip', data, 'GET');
// 过驳
export const batchTurnRefuteLoading = (data) => fetch('/platform/shipDeployPort/batchTurnRefuteLoading', data, 'POST');
// 过驳完成
export const refuteFinish = (id) => fetch(`/platform/shipDeployPort/refuteFulfil/${id}`, {}, 'POST');
// 转船 卸车
export const batchTurnDischarge = (data) => fetch('/platform/shipDeployPort/batchTurnDischarge', data, 'POST');
// 卸车完成
export const unloadFinish = (id) => fetch(`/platform/shipDeployPort/unloadFulfil/${id}`, {}, 'POST');
//回退委托车
export const vehicleErrorFallback = (data) => fetch('/platform/vehicleDeployCar/vehicleErrorFallback', data, 'POST');
//分配委托车-查询
export const selectUnAssignedVehicle = (data) => fetch('/platform/shipDeployPort/selectUnAssignedVehicle', data, 'GET');
//分配委托车-确认
export const assignVehicle = (data) => fetch('/platform/shipDeployPort/assignVehicle', data, 'POST');
/**
 *装卸管理
 */
export const dockInfoCvPageList = (data) => fetch('/platform/transportScanOperation/pageShipOperateList', data, 'GET');

// 装车车辆查询
export const loadingPageList = (data) => fetch('/platform/transportChild/getLoadingPageList', data, 'GET');
// 装车车辆查询
export const loadingChildPageList = (data) => fetch('/platform/transportChild/getLoadingChildList', data, 'GET');
// 批量装车
export const batchFinish = (data) => fetch('/platform/deployDriver/startLoading', data, 'POST');


export const dockInfoCvGetCarByShipId = (id, data) => fetch(`/platform/ship-deploy-car/getCarByShipId/${id}`, data, 'GET');

export const dockInfoCvAdd = (data) => fetch('/platform/dock-info-cv/add', data, 'POST');

export const dockInfoCvFail = (id) => fetch(`/platform/dock-info-cv/fail/${id}`, {}, 'POST');

export const dockInfoCvDetail = (id) => fetch(`/platform/dock-info-cv/detail/${id}`, {}, 'GET');
// 根据港口id查询可装委托车的船舶
export const dockInfoCvSelectPortShip = (id) => fetch('/platform/shipDeployPort/selectPortShip', { 'portId': id }, 'GET');
// 获取卸车车辆
export const getUnloadList = (data) => fetch('/platform/ship-deploy-car/getCarsByOutInShip', data, 'GET');
// 根据港口获取船舶
export const dockInfoCvSelectPorts = (data) => fetch('/platform/ship-deploy-car/getShipByUnloadPort', data, 'GET');
//手动装车
export const dockInfoCvAddShipScanLoading = (data) => fetch('/platform/transportScanOperation/addShipScanLoading', data, 'POST');
//手动卸车
export const dockInfoShipScanUnloading = (data) => fetch('/platform/transportScanOperation/addShipScanDelivery', data, 'POST');

/**
 *过驳管理
 */
export const transferInfoCvPageList = (data) => fetch('/platform/shipDeployChange/pageList', data, 'GET');

export const getPorts = (data) => fetch('/platform/vehicle-deploy-car-cv/getPorts', data, 'GET');

export const getShips = (data) => fetch('/platform/ship-deploy-car/getShips', data, 'GET');

export const transferInfoCvDelete = (id) => fetch(`/platform/shipDeployChange/delete/${id}`, {}, 'POST');

// 详情
// export const transferInfoCvDetail= ( id ) => fetch( `/platform/transferInfo/detail/${id}`, {}, 'GET')
export const transferInfoCvDetail = (id) => fetch(`/platform/shipDeployChange/detail/${id}`, {}, 'GET');
// 过驳、转船详情委托车分页查询
export const pageLighteringList = (id) => fetch('/platform/vehicleDeployCar/pageLighteringList', id, 'GET');

export const transferInfoCvAdd = (data) => fetch('/platform/shipDeployChange/addTransferShip', data, 'POST');

export const transferInfoCvUpdate = (data) => fetch('/platform/shipDeployChange/update', data, 'POST');

/**
 *转船管理
 */
export const changeShipInfoCvPageList = (data) => fetch('/platform/shipDeployChange/pageList', data, 'GET');
export const getShipInfo = (id) => fetch(`/platform/shipDeploy/shipDeploymentDetails/${id}`, {}, 'GET');
// 查询运输中的船舶
export const changeShipSelectShipByInTask = (data) => fetch('/platform/supplierShip/selectShipByInTask', data, 'GET');

export const changeShipInfoCvGetPorts = (data) => fetch('/platform/vehicle-deploy-car-cv/getPorts', data, 'GET');
//查询可转船、过驳的的船舶
export const changeShipSelectShipInByFree = (id) => fetch('/platform/supplierShip/selectShipInByFree', { 'shipId': id }, 'GET');

export const changeShipSelectCarByShipIdAndOut = (data) => fetch('/platform/vehicleDeployCar/selectCarByShipIdAndOut', data, 'GET');

export const changeShipInfoCvDelete = (id) => fetch(`/platform/change-ship-info-cv/delete/${id}`, {}, 'POST');

// export const changeShipInfoCvDetail= ( id ) => fetch( `/platform/change-ship-info-cv/detail/${id}`, {}, 'GET')
export const changeShipInfoCvDetail = (id) => fetch(`/platform/shipDeployChange/detail?id=${id}`, {}, 'GET');

export const changeShipInfoCvAdd = (data) => fetch('/platform/shipDeployChange/addAnotherShip', data, 'POST');

export const changeShipInfoCvUpdate = (data) => fetch('/platform/change-ship-info-cv/update', data, 'POST');

/**
 *转船管理
 */
export const stopShipCvPageList = (data) => fetch('/platform/stop-ship-cv/pageList', data, 'GET');

export const stopShipCvDetail = (id) => fetch(`/platform/stop-ship-cv/detail/${id}`, {}, 'GET');

export const getStopByDeployId = (id) => fetch(`/platform/ship-deploy-car/getStopByDeployId/${id}`, {}, 'GET');

export const stopShipCvAdd = (data) => fetch('/platform/stop-ship-cv/add', data, 'POST');

export const stopShipCvUpdate = (data) => fetch('/platform/stop-ship-cv/update', data, 'POST');

/**
 *集港管理
 */
export const vehicleDeployInfoCvPortList = (data) => fetch('/platform/portFocusManage/pageList', data, 'GET');
export const vehicleDeployInfoCvportFocusPageList = (data) => fetch('/platform/portFocusManage/portFocusPageList', data, 'POST');
/**
 *委托车跟踪
 */
export const vehicleDeployInfoCvCarList = (data) => fetch('/platform/EntrustedTracking/pageList', data, 'POST');

export const vehicleDeployInfoCvCarDetail = (id) => fetch('/platform/EntrustedTracking/getdetailById', { 'id': id }, 'GET');
//委托车线路运输图
export const EntrustedTrackingGetJWtitud = (id) => fetch('/platform/EntrustedTracking/getJWtitud', { 'id': id }, 'GET');
//委托车运输流程
export const EntrustedTrackingGetWayMsg = (id) => fetch('/platform/EntrustedTracking/getWayMsg', { 'id': id }, 'GET');

/**
 * 公路跟踪
 */
export const vehicleDeployInfoCvFleetList = (data) => fetch('/platform/HighwayTrackMes/pageList', data, 'GET');

export const vehicleDeployInfoCvFleetDetail = (id) => fetch('/platform/HighwayTrackMes/getDeatilsById', { 'id': id }, 'GET');
export const getCarDeatilsById = (data) => fetch(`/platform/HighwayTrackMes/getCarDeatilsById?id=${data.id}&page=${data.page}&rows=${data.rows}`, {}, 'GET');
//当前位置
export const HighwayTrackMesSummaryHighwayLongitude = (id) => fetch('/platform/HighwayTrackMes/SummaryHighwayLongitude', { 'id': id }, 'GET');
//委托车
export const HighwayTrackMesselVehicleDeployCarCvByDriveId = (id) => fetch('/platform/HighwayTrackMes/selVehicleDeployCarCvByDriveId', { 'id': id }, 'GET');

/**
 * 水路跟踪
 */
export const trackPageList = (data) => fetch('/platform/shipDeploy/pageTrackList', data, 'GET');
//详情
export const trackDetail = (id) => fetch('/platform/vehicle_location_info/WaterDetails', { 'id': id }, 'GET');
//委托车信息
export const entrustedInfo = (id) => fetch('/platform/vehicle_location_info/entrustedInfo', { 'basicId': id }, 'GET');
//托运路线
export const waterShipLocation = (id) => fetch('/platform/vehicle_location_info/waterShipLocation', { 'id': id }, 'GET');

/**
 * 质损上报
 */
// 验证任务编号
export const deployDriverSelectDeploy = (data) => fetch('/platform/deployDriver/selectDeploy', data, 'GET');

export const taskNumberCheck = (id) => fetch(`/platform/vehicleMassLossInfo/queryBasicInfo?billNumber=${id}`, {}, 'GET');

// 质损上报
export const massLossReport = (data) => fetch('/platform/vehicleMassLossInfo/add', data, 'POST');
// 质损上报 获取车牌号/船名
export const taskLicensePlate = (type) => fetch(`/platform/qualitative/damage/escalation/taskLicensePlate?type=${type}`, {}, 'GET');
// 质损上报 获取质损类型/质损部位
export const reportingCategory = () => fetch('/platform/qualitative/damage/escalation/reportingCategory', {}, 'GET');
// 质损上报 质损车列表
export const deploymentCarList = (data) => fetch('/platform/qualitative/damage/escalation/deploymentCarList', data, 'GET');

// 质损列表查询
export const qualityDamageList = (data) => fetch('/platform/vehicleMassLossInfo/listPage', data, 'GET');
//质损列表分页查询
export const tableListPage = (data) => fetch('/platform/vehicleMassLossInfo/listPage', data, 'GET');
// 质损完善下拉
export const perfectDropDownDataGather = (data) => fetch('/platform/vehicleMassLossInfo/perfectDropDownDataGather', data, 'GET');
// 质损完善
export const perfectQualityLoss = (data) => fetch('/platform/vehicleMassLossInfo/perfectQualityLoss', data, 'POST');
// 质损完成
export const deleteQualityLoss = (data) => fetch('/platform/vehicleMassLossInfo/batchDelete', data, 'POST');
// 质损完成
export const completionQualityLoss = (data) => fetch('/platform/vehicleMassLossInfo/completionQualityLoss', data, 'POST');
// 质损列表详情
export const qualityDamageDetail = (id) => fetch(`/platform/vehicleMassLossInfo/detail?id=${id}`, {}, 'GET');
// 质损列表完善
// 维修信息
export const qualityDamageRepair = (data) => fetch('/platform/vehicleMassLossInfo/setMaintainInfo', data, 'POST');
// 保险信息
export const qualityDamageInsurance = (data) => fetch('/platform/vehicleMassLossInfo/setInsuranceInfo', data, 'POST');

/**
 * 统计分析报表
 */
// 品牌运量统计分析列表
export const statisticalAnalysisOfBrandTrafficList = (data) => fetch('/platform/vehicleDeployCar/deployCarCvCountByLineAndBrandPageList', data, 'GET');
// 发运统计报表
export const getShippingList = (data) => fetch('/platform/vehicleDeployCar/statisticsReportQuery', data, 'GET');
// 船舶运行动态表
export const shipRunningDynamicTableList = (data) => fetch('/platform/shipOperationInfo/queryList', data, 'GET');
//集港信息统计-港口名称查询
export const getPortsList = (data) => fetch('/platform/portFocusManage/getPorts', data, 'GET');
//集港信息统计-品牌名称查询
export const getPortName = (data) => fetch('/platform/portFocusManage/getBrands', data, 'GET');
//集港信息统计-集港信息查询
export const getPageListByPB = (data) => fetch('/platform/portFocusManage/pageListByPB', data, 'GET');
//零星车统计报表-查询
export const getListPage = (data) => fetch('/platform/sporadicVehicleStatisticsReport/listPage', data, 'POST');
//零星车统计报表-详情
export const vehicleDeployInfoDetail = (data) => fetch('/platform/sporadicVehicleStatisticsReport/detail', data, 'POST');

export const forceArrive = (data) => fetch('/platform/transportChild/forceArrive', data, 'POST');

export const deleteShipPort = (data) => fetch('/platform/shipDeployPort/deleteShipPort', data, 'POST');

export const operateRecordReport = (data) => fetchNew('/vehicleDeployCar/operateRecordReport', data, 'GET');

export const yearMonthPlanAddAll = (data) => fetchNew('/yearMonthPlan/all/addAll', data, 'POST');

export const yearMonthPlanList = (data) => fetchNew('/yearMonthPlan/all/list', data, 'GET');

export const yearMonthPlanAllLockingAll = (data) => fetchNew('/yearMonthPlan/all/lockingAll', data, 'GET');

export const yearMonthPlanAllDeleteAll = (data) => fetchNew('/yearMonthPlan/all/deleteAll', data, 'GET');

export const yearMonthPlanUpdateAll = (data) => fetchNew('/yearMonthPlan/all/updateAll', data, 'POST');

export const getMapCustomer = (data) => fetchNew('/yearMonthPlanWaterway/all/getMapCustomer', data, 'POST');

export const getMapBrands = (data) => fetchNew('/yearMonthPlanWaterway/all/getMapBrands', data, 'POST');

export const getMapPort = (data) => fetchNew('/yearMonthPlanWaterway/all/getMap', data, 'POST');

export const yearMonthPlanWaterwayAddAll = (data) => fetchNew('/yearMonthPlanWaterway/all/addAll', data, 'POST');

export const yearMonthPlanWaterwayAddList = (data) => fetchNew('/yearMonthPlanWaterway/all/list', data, 'POST');

export const yearMonthPlanWaterwayAddUpdateAll = (data) => fetchNew('/yearMonthPlanWaterway/all/updateAll', data, 'POST');

export const yearMonthPlanWaterwayAddDeleteAll = (data) => fetchNew('/yearMonthPlanWaterway/all/deleteAll', data, 'GET');

export const yearMonthPlanWaterwayGetMapWater = (data) => fetchNew('/yearMonthPlanWaterway/all/getMapWater', data, 'POST');

export const yearMonthPlanHighwayAddAll = (data) => fetchNew('/yearMonthPlanHighway/all/addAll', data, 'POST');

export const yearMonthPlanHighwayList = (data) => fetchNew('/yearMonthPlanHighway/all/list', data, 'POST');

export const yearMonthPlanHighwayDeleteAll = (data) => fetchNew('/yearMonthPlanHighway/all/deleteAll', data, 'GET');

export const yearMonthPlanHighwayUpdateAll = (data) => fetchNew('/yearMonthPlanHighway/all/updateAll', data, 'POST');

export const yearMonthPlanHighwayBrandList = (data) => fetchNew('/car/brand/list', data, 'GET');

/**
 * 变更管理
 */
//变更管理-查询
export const getTableDataList = (data) => fetchNew('/change/review/list', data, 'POST');
//变更管理-历史审核记录
export const getHistoryReview = (id) => fetchNew(`/change/review/detail/${id}`, {}, 'GET');
//变更管理-取消审核
export const withdrawReview = (data) => fetchNew('/change/review/withdraw', data, 'POST');
//变更管理-提交审核
export const resubmitReview = (data) => fetchNew('/change/review/resubmit', data, 'POST');
//变更管理-详情
export const getDetail2 = (id) => fetchNew(`/change/review/detail2/${id}`, {}, 'GET');
//变更管理-删除
export const changeDelete = (id,type) => fetchNew(`/change/review/delete/${id}?type=${type}`, {}, 'DELETE');

export const auditing = (data) => fetchNew('/change/review/auditing', data, 'POST');
